import { httpService } from "./apis";
import Cookies from "js-cookie";

export const GetFacilities = async () => {
  try {
    const result = await httpService.get("getapis/get-all-facility");

    if (result && Array.isArray(result.records)) {
      return result.records;
    } else {
      throw new Error("Unexpected response structure");
    }
  } catch (error) {
    console.error("GetFacilities error:", error.message || "Unknown error");
    return { error: error.message || "Failed to fetch facilities" };
  }
};

export const FetchFacilitiesOne = async (token) => {
  try {
    const result = await httpService.post("postapis/facility-details", { token });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("FetchFacilitiesOne error:", error.message || "Unknown error");
    return { error: error.message || "Failed to fetch facility details" };
  }
};

export const GetFacilitiesByFilter = async (complete_address, checkin, checkout, guests, purpose, postalCode, locality, state, country, lat, lon) => {
  try {
    const result = await httpService.post("postapis/facility-filter", { complete_address, checkin, checkout, guests, purpose, postalCode, locality, state, country, lat, lon });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("GetFacilitiesByFilter error:", error.message || "Unknown error");
    return { error: error.message || "Failed to fetch facilities" };
  }
};

export const GetPurposeWiseFacilitiesAmount = async (token, purpose, from_time, to_time, day) => {
  if (!token || !purpose || !from_time || !to_time || !day) {
    console.error("Invalid payload: Missing required fields");
    return { error: "Missing required fields" };
  }

  try {
    const result = await httpService.post("postapis/purpose-wise-facilities-details", { token, purpose, from_time, to_time, day });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    if (!result?.record) {
      throw new Error("API Error: Data not found");
    }

    return result;
  } catch (error) {
    console.error("GetPurposeWiseFacilitiesAmount error:", error.message || "Unknown error");
    return { error: error.message || "Failed to fetch data" };
  }
};

export const CheckFacilityAvailability = async (facilities_token, checkin, checkout, customerToken) => {
  try {
    const response = await httpService.post("postapis/check-facility-availability", { facilities_token, checkin, checkout, customerToken });

    const result = response?.data || response; // normalize response

    if (result?.success === false) {
      return { error: result.message || "Facility not available" };
    }

    return result;
  } catch (error) {
    console.error(
      "CheckFacilityAvailability error:",
      error.message || "Unknown error"
    );
    return { error: error.message || "Failed to check facility availability" };
  }
};


// Geocode a UK postcode into City / State (County) / Country
export const GeocodePostcode = async (postcode) => {
  try {
    const result = await httpService.get("postapis/geocode-postcode", { postcode });
    return result;
  } catch (error) {
    console.error("GeocodePostcode error:", error.message || "Unknown error");
    return { error: error.message || "Address lookup failed" };
  }
};

// Customer Registration
export const CustomerRegistration = async (name, phoneNum, email, password, address_line1, city, state, post_code, country) => {
  try {
    const result = await httpService.post("postapis/customer-registration", { name, phoneNum, email, password, address_line1, city, state, post_code, country });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("CustomerRegistration error:", error.message || "Unknown error");
    return { error: error.message || "Failed to register customer" };
  }
};

// Customer login
export const CustomerLogin = async (email, password) => {
    try {
        const result = await httpService.post("postapis/customer-login", { email, password });

        if (result?.success === false) {
            throw new Error(result.message || "API Error: Unsuccessful request");
        }

        const token = result?.record?.authToken;
        const userEmail = result?.record?.email;

        const consentCookie = Cookies.get("cookie_consent");
        let consent = null;

        if (consentCookie) {
            try { consent = JSON.parse(consentCookie).consent; } catch {}
        }

        if (token) {
            if (consent === "accepted") {
                localStorage.setItem("authToken", token);
            } else {
                sessionStorage.setItem("authToken", token);
            }
        }

        if (userEmail) {
            if (consent === "accepted") {
                localStorage.setItem("customerEmail", userEmail);
            } else {
                sessionStorage.setItem("customerEmail", userEmail);
            }
        }

        return result;
    } catch (error) {
        console.error("CustomerLogin error:", error.message || "Unknown error");
        return { error: error.message || "Login failed" };
    }
};

// Create Payment Orders in Payment gateway
export const CreatePaymentOrder = async (amount, success_url, order_id, customer_token, facilities_token, hosttoken, order_token, payment_deferred, pay_direct = false) => {
  try {
    const result = await httpService.post("postapis/checkout-payments", { amount, success_url, order_id, customer_token, facilities_token, hosttoken, order_token, payment_deferred, pay_direct });

    if (!result || result.error) {
      // expired carried on the Error object (not just the message) so the caller can tell a
      // session-expired 409 apart from any other checkout-payments failure.
      throw Object.assign(new Error(result?.error || "API Error: Unsuccessful request"), { expired: result?.expired === true });
    }
    console.log("result in create payment order",result);
    return result;
  } catch (error) {
    console.error("CreatePaymentOrder error:", error.message || "Unknown error");
    return { error: error.message || "Failed to create payment order", expired: error?.expired === true };
  }
};

// Create Facilities Order
export const CreateFacilitiesOrder = async (customer_token, hosttoken, facilities_token, checkin, checkout, total_guest, rent, booking_fee, total, purpose, rentPerHour, booking_reason, payment_deferred, initial_amount_paid, remaining_payment_amount, remaining_payment_due_date, pay_direct = false, selected_extras = []) => {
  try {
    const result = await httpService.post("postapis/create-order", { customer_token, hosttoken, facilities_token, checkin, checkout, total_guest, rent, booking_fee, total, purpose, rentPerHour, booking_reason, payment_deferred, initial_amount_paid, remaining_payment_amount, remaining_payment_due_date, pay_direct, selected_extras });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    alert(error.message);
    console.error("CreateFacilitiesOrder error:", error.message || "Unknown error");
    return { error: error.message || "Failed to create order" };
  }
};

// Get Customer Details
export const GetGuestAccounts = async (customer_token) => {
  try {
    const result = await httpService.post("postapis/guest-accounts", { customer_token });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("GetGuestAccounts error:", error.message || "Unknown error");
    return { error: error.message || "Failed to fetch guest accounts" };
  }
};

// Update orders Status ********************

export const UpdateOrdersStatus = async (order_token) => {
  try {
    const result = await httpService.post("postapis/update-order-status", { order_token });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("UpdateOrdersStatus error:", error.message || "Unknown error");
    return { error: error.message || "Failed to update order status" };
  }
};

// Confirm all recurring orders in group + send ONE summary email
export const UpdateRecurringGroupStatus = async (order_token) => {
  try {
    const result = await httpService.post("postapis/update-recurring-group-status", { order_token });
    if (result?.success === false) {
      throw new Error(result.message || "API Error");
    }
    return result;
  } catch (error) {
    console.error("UpdateRecurringGroupStatus error:", error.message || "Unknown error");
    return { error: error.message || "Failed to update recurring group status" };
  }
};

// Generate a Revolut payment link for early manual payment of deferred remaining balance
export const GenerateEarlyPaymentLink = async (order_token, redirect_url) => {
  try {
    const result = await httpService.post("postapis/generate-early-payment-link", { order_token, redirect_url });
    if (result?.success === false) {
      throw new Error(result.message || "API Error");
    }
    return result;
  } catch (error) {
    console.error("GenerateEarlyPaymentLink error:", error.message || "Unknown error");
    return { error: error.message || "Failed to generate payment link" };
  }
};

// Generate a Revolut payment link for an approved booking (host approved, guest pays from dashboard)
export const PayApprovedBooking = async (order_token, redirect_url) => {
  try {
    const result = await httpService.post("postapis/pay-approved-booking", { order_token, redirect_url });
    if (result?.success === false) {
      throw new Error(result.message || "API Error");
    }
    return result;
  } catch (error) {
    console.error("PayApprovedBooking error:", error.message || "Unknown error");
    return { error: error.message || "Failed to generate payment link" };
  }
};

// Cancel a pending booking when guest navigates away from the Revolut payment page
export const CancelPendingBooking = async (order_token) => {
  try {
    const result = await httpService.post("postapis/cancel-pending-booking", { order_token });
    return result;
  } catch (error) {
    console.error("CancelPendingBooking error:", error.message || "Unknown error");
    return { error: error.message || "Failed to cancel booking" };
  }
};

// Capture early deferred payment from dashboard "Pay Now" — uses existing auth hold if available
export const CaptureEarlyPayment = async (order_token) => {
  try {
    const result = await httpService.post("postapis/capture-early-payment", { order_token });
    if (result?.success === false) {
      throw new Error(result.message || "API Error");
    }
    return result;
  } catch (error) {
    console.error("CaptureEarlyPayment error:", error.message || "Unknown error");
    return { error: error.message || "Failed to capture payment" };
  }
};

// Force a fresh Revolut status check for one order — called 2 minutes after payment creation so a
// guest isn't stuck seeing a stale "pending" status if the original one-shot check above ran before
// Revolut finished settling, and also called right after a guest cancels a booking (before the page
// reloads) so the reload shows the reconciled refund status instead of a stale "processing".
// Safe to call more than once (backend short-circuits once terminal). Accepts either a plain
// order_id (existing callers) or an { order_id, order_token } object — order_token is what's already
// available at cancel time, no need to look up order_id separately.
export const ReconcileOrderStatus = async (identifier) => {
  try {
    const payload = (typeof identifier === "object" && identifier !== null) ? identifier : { order_id: identifier };
    const result = await httpService.post("postapis/reconcile-order-status", payload);

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("ReconcileOrderStatus error:", error.message || "Unknown error");
    return { error: error.message || "Failed to reconcile order status" };
  }
};

// Confirm deferred remaining payment after guest pays via emailed link
export const ConfirmDeferredPayment = async (order_token) => {
  try {
    const result = await httpService.post("postapis/confirm-deferred-payment", { order_token });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("ConfirmDeferredPayment error:", error.message || "Unknown error");
    return { error: error.message || "Failed to confirm deferred payment" };
  }
};

// Get customer booking
export const GetCustomerBooking = async (customer_token) => {
  try {
    const result = await httpService.post("postapis/guest-booking", { customer_token });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("GetCustomerBooking error:", error.message || "Unknown error");
    return { error: error.message || "Failed to fetch customer booking data" };
  }
};
// Cancel Booking API Call
export const CancelBooking = async (payment_id, order_token, amount) => {
  try {
    console.log("in cancel booking", payment_id, order_token, amount);
    const result = await httpService.post("postapis/cancel-order", { payment_id, order_token, amount });

    if (result?.success === false) {
      throw new Error(result.message || "Cancel booking failed");
    }

    return result;
  } catch (error) {
    console.error("CancelBooking error:", error.message || "Unknown error");
    return { error: error.message || "Failed to cancel booking" };
  }
};


// Find the message if yes or not you self

export const FindMessagesSelf = async (customer_token) => {
  try {
    const result = await httpService.post("postapis/get-all-message", { customer_token });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("FindMessagesSelf error:", error.message || "Unknown error");
    return { error: error.message || "Failed to fetch messages" };
  }
};

// Match exists facilities time available or not available

export const MatchAvailableFacilitiesTime = async (facilities_token, purpose, checkin, checkout) => {
  try {
    const result = await httpService.post("postapis/match-available-facilities-time", { facilities_token, purpose, checkin, checkout });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("MatchAvailableFacilitiesTime error:", error.message || "Unknown error");
    return { error: error.message || "Failed to match available facility time" };
  }
};

// Create New Ticket 

export const CreateNewTicket = async (ticketData) => {
  try {
    const result = await httpService.post("postapis/new-ticket", ticketData);

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("CreateNewTicket error:", error.message || "Unknown error");
    return { error: error.message || "Failed to create ticket" };
  }
};

// Find All Ticket 

export const AllTickets = async (guest_token) => {
  try {
    const result = await httpService.post("postapis/all-ticket", { guest_token });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("AllTickets error:", error.message || "Unknown error");
    return { error: error.message || "Failed to fetch tickets" };
  }
};

// Find ticket & message

export const TicketsMesages = async (ticket_id) => {
  try {
    const result = await httpService.post("postapis/all-ticket-message", { ticket_id });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("TicketsMesages error:", error.message || "Unknown error");
    return { error: error.message || "Failed to fetch ticket messages" };
  }
};

// Submit ticket & message

export const SubmitTicket = async (ticketData) => {
  try {
    const result = await httpService.post("postapis/send-ticket-message", ticketData);

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("SubmitTicket error:", error.message || "Unknown error");
    return { error: error.message || "Failed to send ticket message" };
  }
};

// Change Status of ticket

export const ChangeTicketStatus = async (status, ticket_id) => {
  try {
    const result = await httpService.post("postapis/change-ticket-status", { status, ticket_id });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("ChangeTicketStatus error:", error.message || "Unknown error");
    return { error: error.message || "Failed to change ticket status" };
  }
};

// Forgot password
export const forgotPasswordAPI = async (email) => {
  try {
    const res = await httpService.post("postapis/forgot-guest-password", { email });
    return res;
  } catch (err) {
    return err.response ? err.response : { error: "Network error" };
  }
};

export const resetPasswordAPI = async (token, newPassword) => {
  try {
    const result = await httpService.post("postapis/reset-guest-password", { token, newPassword });

    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }

    return result;
  } catch (error) {
    console.error("resetPasswordAPI error:", error.message || "Unknown error");
    return { error: error.message || "Failed to reset password" };
  }
};

export const GetFacilityDataByToken = async (token) => {
  try {
    const result = await httpService.post("postapis/find-facility-by-token", { token });
    return result;
  } catch (error) {
    console.error("GetFacilityDataByToken error:",error.message || "Unknown error");
    return {
      error: error.message || "Failed to fetch facility data",
    };
  }
};

export const Get_Facilities_list = async () => {
  try {
    const  data  = await httpService.get("postapis/get_facilities");
    return data;
  } catch (error) {
    console.error("Get_Facilities_list error:", error.message || "Unknown error");
    return {
      error: error.message || "Failed to fetch facilities",
    };
  }
};

export const updateGuestProfile = async (formData) => {
  try {
    const result = await httpService.post("postapis/update-guest-accounts", formData);
    return result;
  } catch (error) {
    console.error("updateGuestProfileAPI error:", error.message || "Unknown error");
    return {
      error: error.message || "Failed to update profile",
    };
  }
};

export const changeGuestPassword = async (customer_token, old_password, new_password) => {
  try {
    const result = await httpService.post("postapis/update-guest-password", {
      customer_token,
      old_password,
      new_password,
    });
    return result;
  } catch (error) {
    console.error("changeGuestPasswordAPI error:", error.message || "Unknown error");
    return {
      error: error.message || "Failed to change password",
    };
  }
};


export const getFacilityAvailabilityCalendar = async (facilities_token) => {
  try {
    const result = await httpService.post("postapis/get-facility-availability-calendar", { facilities_token });
    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }
    return result;
  } catch (error) {
    console.error("getFacilityAvailabilityCalendar error:", error.message || "Unknown error");
    return { error: error.message || "Failed to fetch facility availability" };
  }
};

export const CheckRecurringAvailability = async (facilities_token, checkin, checkout, frequency, occurrences, customerToken, purpose) => {
  try {
    const result = await httpService.post("postapis/check-recurring-availability", {
      facilities_token, checkin, checkout, frequency, occurrences, customerToken, purpose
    });
    if (result?.success === false) {
      return { error: result.message || "Recurring availability check failed" };
    }
    return result;
  } catch (error) {
    console.error("CheckRecurringAvailability error:", error.message || "Unknown error");
    return { error: error.message || "Failed to check recurring availability" };
  }
};

export const CreateRecurringOrders = async (customer_token, hosttoken, facilities_token, dates, total_guest, purpose, frequency, occurrences, rent, rentPerHour, booking_reason, guest_defer, pay_direct = false, selected_extras = []) => {
  try {
    const result = await httpService.post("postapis/create-recurring-orders", {
      customer_token, hosttoken, facilities_token, dates, total_guest, purpose, frequency, occurrences, rent, rentPerHour, booking_reason, guest_defer, pay_direct, selected_extras
    });
    if (result?.success === false) {
      throw new Error(result.message || "API Error: Unsuccessful request");
    }
    return result;
  } catch (error) {
    console.error("CreateRecurringOrders error:", error.message || "Unknown error");
    return { error: error.message || "Failed to create recurring orders" };
  }
};
